export default "__VITE_ASSET__Dp6$kFGE__"